export const API_URL = process.env.NODE_ENV === 'production' ? 'https://arvel.app/graphql' : 'http://localhost:8080/graphql'